import React from "react";
import { useContext } from "react";
import { MapContext } from "../Context/OptionsApi";

function Header(props) {
  const { analysis ,setAnalysis } = useContext(MapContext);

  const handleWeek =(event) => {
    setAnalysis(event.target.value);
  }; 
  return (
    <div className="shadow px-2 py-1  text-sm grid grid-cols-3 items-center mx-5 my-2">
      <div className="col-start-1 " >
        <p className="ml-1 text-slate-800 text-[10px]">SELECT ANALYSIS</p>
        <select name="" id=""  onChange={handleWeek}  value={analysis} className="py-0.5 border outline-none bg-gray-50 rounded-sm bottom-4 border-black">
          <option value="Infestation Comparison (2 weeks)">Infestation Comparison (3 weeks)</option>
          {/* <option  value="Infestation Comparison (3 weeks)">Infestation Comparison (3 weeks)</option> */}
          <option disabled  value="Infestation Prediction Alert">Infestation Prediction Alert</option>
        </select>
      </div>
        <p className="font-medium text-center  col-start-2 underline-offset-4 decoration-slate-800" > 
          DASHBOARD VIEW
        </p>
        {/* <div className="  gap-3 flex justify-between items-center">

      <div className="border-2 border-blue-400 rounded-sm  bg-blue-400 flex justify-between">
        <input  className="p-1 focus:outline-none" type="text" placeholder="search" />
        <CiSearch  color="#1e293b" size={24} />
      </div>
      <button className="font-medium bg-green-500 text-white border rounded-md px-2 py-1" >Add</button>
      </div> */}
    </div>
  );
}

export default Header;
